import React from "react";
import "./Contactfooter.css";
import { Link } from "react-router-dom";
/**
 * Hero-style footer section with background image and centered copy
 * tailored for Emerald Appraisal Services.
 *
 * Example:
 * <Contactfooter background={`${process.env.PUBLIC_URL}/emerald-hero.jpg`} />
 */
const Contactfooter = ({
  background = `${process.env.PUBLIC_URL}/emerald-hero.jpg`,
  onDiscover,
}) => {
  return (
    <section
      className="Contactfooter"
      style={{ "--cf-bg": `url(${background})` }}
      aria-label="Emerald Appraisal Services contact banner"
      role="banner"
    >
      <div className="Contactfooter__overlay" aria-hidden="true" />
      <div className="Contactfooter__pattern" aria-hidden="true" />
      <div className="Contactfooter__container">
        <p className="Contactfooter__eyebrow">
          CERTIFIED RESIDENTIAL APPRAISALS ACROSS PUGET SOUND
        </p>

        <h1 className="Contactfooter__title">
          Clear Valuations,
          <br className="Contactfooter__br" />
          Confident Decisions
        </h1>

        <Link
          to="/contact"
          className="Contactfooter__cta"
          aria-label="Request an appraisal from Emerald Appraisal Services"
        >
          REQUEST AN APPRAISAL
          <svg
            className="Contactfooter__cta-icon"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z"
              fill="currentColor"
            />
          </svg>
        </Link>
      </div>
    </section>
  );
};

export default Contactfooter;